"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _types = require("@polkadot/types");

const toHump = name => {
  return name.replace(/_(\w)/g, (_, l) => l.toUpperCase());
};

class GenericEvent extends _types.GenericEvent {
  get argsDef() {
    try {
      var _$exec;

      const meta = this.meta.toJSON();
      const args = meta === null || meta === void 0 ? void 0 : meta.args;

      if (!args || !args.length) {
        return {};
      }

      const doc = meta.documentation.join('\n').replace(/\\/g, '');
      const def = (_$exec = /\[([\w\s,]*)\]/.exec(doc)) === null || _$exec === void 0 ? void 0 : _$exec[1].split(',').map(s => s.trim());
      const data = this.data.toJSON();

      if (!def || def.length !== args.length || def.length !== data.length) {
        return null;
      }

      return data.reduce((result, curr, index) => {
        const name = toHump(def[index]);
        result[name] = curr;
        return result;
      }, {});
    } catch {
      return null;
    }
  }

}

exports.default = GenericEvent;